export { default } from './SkeletonBreakingDeals';
